import axios from "axios";
class CreateToken {
  async postForToken(url, params) {
    let serverurl = url;
    var response = await axios.post(serverurl, {
      UserName: params.UserName,
      Password: params.Password, // This is the body part
    });

    return response;
  }
}
export default new CreateToken();
